import { render, staticRenderFns } from "./SearchShop.vue?vue&type=template&id=c778dcd6&scoped=true"
import script from "./SearchShop.vue?vue&type=script&lang=ts"
export * from "./SearchShop.vue?vue&type=script&lang=ts"
import style0 from "./SearchShop.vue?vue&type=style&index=0&id=c778dcd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c778dcd6",
  null
  
)

export default component.exports